import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResumeCardEducation extends BaseModel {
  static override constructorName = 'ResumeCardEducationModel'

  education: string = ''
  'education_facility': string = ''
  faculty: string = ''
  'process_of_studyng': string = ''
  'study_level': string = ''

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResumeCardEducation)
